<template>
  <Lottie id="map-germany" class="animation" :options="mapAnimationOptions" />
</template>

<script>
import Lottie from 'chimera/all/components/Lottie'
import { getWithText } from 'chimera/all/assets/lottie/maps/germany.js'

export default {
  name: 'MapGermany',

  components: {
    Lottie,
  },

  props: {
    text: {
      type: String,
      default: 'braucht einen Spezialisten.',
    },
  },

  computed: {
    /**
     *
     * @returns {{animationData: *}}
     */
    mapAnimationOptions() {
      return {
        animationData: getWithText(this.text),
      }
    },
  },
}
</script>
